import AgencyDropdown from "pages/capture/OpportunitySearch/SearchFilters/AgencyDropdown";
import { func } from "prop-types";

import classes from "../../shared/fields/FieldRow.module.scss";
import RemoveButton from "../../shared/fields/RemoveButton";
import { formDataPropType } from "../propTypes";
import samGovClasses from "../SamGovPanel.module.scss";

const FIELD_ID = "departmentAgencies";

const ProfileAgency = ({ formData, onDisable, onValueChange }) => {
  return (
    <>
      {formData[FIELD_ID] !== null && (
        <div className={classes.formRow}>
          <AgencyDropdown
            value={formData[FIELD_ID]}
            onChange={onValueChange(FIELD_ID)}
            labelClassName={samGovClasses.dropdown_label}
          />
          <div className={classes.formRow__disableButton}>
            <RemoveButton onClick={onDisable(FIELD_ID)} />
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileAgency;

ProfileAgency.propTypes = {
  formData: formDataPropType.isRequired,
  onDisable: func.isRequired,
  onValueChange: func.isRequired,
};
